import { useEffect, useState } from 'react';
import useGetPlayerEl from 'chameleon/packages/blue-book-player/hooks/useGetPlayerEl';
import { SELECTORS } from 'chameleon/packages/blue-book-player/constants/selectors';

const useDisableCopyQuestions = () => {
  const [isTextSelected, setIsTextSelected] = useState(false);
  const playerEl = useGetPlayerEl();

  const handleCopy = (event) => {
    if (
      event.target.closest(SELECTORS.QUESTION) ||
      event.target.closest(SELECTORS.SHARED_PASSAGE)
    ) {
      event.preventDefault();
    }
  };

  const handleMouseUp = (event) => {
    if (
      event.target.closest(SELECTORS.QUESTION) ||
      event.target.closest(SELECTORS.SHARED_PASSAGE)
    ) {
      const selection = window.getSelection();
      if (selection && selection.toString().length > 0) {
        setIsTextSelected(true);
      } else {
        setIsTextSelected(false);
      }
    }
  };

  const handleKeydown = (event) => {
    if (event.key === 'Tab' && isTextSelected) {
      setIsTextSelected(false);
    }
  };

  useEffect(() => {
    if (!playerEl) return;

    playerEl.addEventListener('copy', handleCopy);
    document.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('keydown', handleKeydown);

    return () => {
      playerEl.removeEventListener('copy', handleCopy);
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('keydown', handleKeydown);
    };
  }, [playerEl, isTextSelected]);

  return [];
};

export default useDisableCopyQuestions;
